module.exports = __webpack_public_path__ + "img/5325b77.png";